
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGridOffGoogle as ObiGridOffGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-grid-off-google.js';
 
 
 

 
 export const ObiGridOffGoogle = createComponent({
   react: React,
   tagName: 'obi-grid-off-google',
   elementClass: ObiGridOffGoogleElement,
   events: {
     
   }
  });
 
 